import { render, staticRenderFns } from "./Create-Update-Template.vue?vue&type=template&id=598e071e&"
import script from "./Create-Update-Template.vue?vue&type=script&lang=js&"
export * from "./Create-Update-Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports